import React, { useState } from "react";
import Style from "./PrivacyPolicy.module.scss";
import {
  personalInfo,
  personalInfo2,
  userInfo,
  disclosure,
  StorageInfo,
  crossBorder,
} from "../Constants/PrivacyPolicy/Outsideindia";
import Assets from "../Layout/Assets";
function OutSideIndia() {
  const [PrivacyInsideIndia, setPrivacypolicy] = useState(true);
  return (
    <>
    <h3 className={Style.headings}>Privacy Statement</h3>
    <p> We use a secure server for credit card transactions to protect the credit card information of our users. The information we gather from members is not shared with any individual or organization. We also do not sell, rent, or loan any identifiable information at the individual level to any third party.
     </p>
  
    </>
  );
}

export default OutSideIndia;
